export const interactiveDemo2023Gql = `... on landingPageContent2023_interactiveDemo_BlockType {
  typeHandle
  demoEntry(limit:1) {
    slug
  }
}`;
